import React from "react";
import { motion } from "framer-motion";
import { Lightbulb, Gamepad2, Palette, Smartphone, Cpu, Sparkles } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const icons = [Lightbulb, Gamepad2, Palette, Smartphone, Cpu];

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, ease: "easeOut" },
};

export default function AboutSection() {
  const { t } = useLang();

  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div {...fadeUp} className="text-center mb-16">
          <span className="inline-block px-4 py-1 mb-4 text-xs font-bold uppercase tracking-[0.2em] text-brand-cyan border border-brand-cyan/20 rounded-full">
            {t.about.tag}
          </span>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6">
            {t.about.title}
          </h2>
          <p className="font-body text-white/50 max-w-2xl mx-auto text-base leading-relaxed">
            {t.about.description}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {t.about.values.map((val, i) => {
            const Icon = icons[i] || Sparkles;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`about-card-${i}`}
                className="group relative p-6 bg-white/[0.02] border border-white/5 rounded-xl hover:border-brand-orange/30 transition-all duration-500 overflow-hidden"
              >
                <div className="absolute inset-0 bg-gradient-to-b from-brand-orange/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative z-10">
                  <div className="w-10 h-10 flex items-center justify-center mb-4 text-brand-orange group-hover:text-brand-cyan transition-colors duration-500">
                    <Icon size={24} strokeWidth={1.5} />
                  </div>
                  <h3 className="font-display font-semibold text-white text-lg mb-2">{val.title}</h3>
                  <p className="font-body text-white/40 text-sm leading-relaxed">{val.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
